module.exports = __webpack_public_path__ + "img/TRX.64a862e5.png";